<script setup>
import EnterpriseNeed from "@/views/needs/need/Need.vue";
import EcosystemNeed from "@/views/ecosystem/needs/need/Need.vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
</script>

<template>
    <div>
        <EnterpriseNeed v-if="store.getters.isEnterprise"/>
        <EcosystemNeed v-if="store.getters.isEcosystem"/>
    </div>
</template>

<style scoped>

</style>
